import { DolozkaVplyvovFormData } from '../model/sprievodnyDokument/DolozkaVplyvovFormData';

const initFormData = (): DolozkaVplyvovFormData => ({
  charakterMaterialuNelegislativny: false,
  charakterMaterialuLegislativny: false,
  charakterMaterialuTranspozicia: false,
  zoznamTransponovanychPredpisov: '',
  terminZaciatkuPpk: undefined,
  terminUkonceniaPpk: undefined,
  predpokladanyTerminPk: '',
  predpokladanyTerminZp: '',
  predpokladanyTerminRokovanieVlady: '',
  definovanieProblemu: '',
  cieleAVyslednyStav: '',
  dotknuteSubjekty: '',
  alternativneRiesenia: '',
  vykonavaciePredpisyAno: undefined,
  vykonavaciePredpisyText: '',
  transpoziciaGoldplatingAno: undefined,
  transpoziciaPravaEuText: '',
  preskumanieUcelnosti: '',
  vplyvyRozpocetVerejnejSpravyPozitivne: false,
  vplyvyRozpocetVerejnejSpravyZiadne: false,
  vplyvyRozpocetVerejnejSpravyNegativne: false,
  vplyvyRozpocetVerejnejSpravyZabezpeceneAno: false,
  vplyvyRozpocetVerejnejSpravyZabezpeceneNie: false,
  vplyvyRozpocetVerejnejSpravyZabezpeceneCiastocne: false,
  vplyvyRozpoctyObciAVucPozitivne: false,
  vplyvyRozpoctyObciAVucZiadne: false,
  vplyvyRozpoctyObciAVucNegativne: false,
  vplyvyRozpoctyObciAVucZabezpeceneAno: false,
  vplyvyRozpoctyObciAVucZabezpeceneNie: false,
  vplyvyRozpoctyObciAVucZabezpeceneCiastocne: false,
  vplyvNaUdrzatelnostAno: false,
  vplyvNaUdrzatelnostNie: false,
  vplyvyPodnikatelskeProstrediePozitivne: false,
  vplyvyPodnikatelskeProstredieZiadne: false,
  vplyvyPodnikatelskeProstredieNegativne: false,
  vplyvyPodnikatelskeProstredieMspPozitivne: false,
  vplyvyPodnikatelskeProstredieMspZiadne: false,
  vplyvyPodnikatelskeProstredieMspNegativne: false,
  vplyvyPodnikatelskeProstredieZnizovanieByrokracieAno: false,
  vplyvyPodnikatelskeProstredieZnizovanieByrokracieNie: false,
  vplyvyNaLimitVydavkovPozitivne: false,
  vplyvyNaLimitVydavkovZiadne: false,
  vplyvyNaLimitVydavkovNegativne: false,
  socialneVplyvyPozitivne: false,
  socialneVplyvyZiadne: false,
  socialneVplyvyNegativne: false,
  vplyvyZivotneProstrediePozitivne: false,
  vplyvyZivotneProstredieZiadne: false,
  vplyvyZivotneProstredieNegativne: false,
  posudzovanyPodlaZakonaAno: false,
  posudzovanyPodlaZakonaNie: false,
  vplyvyInformatizaciaSpolocnostiPozitivne: false,
  vplyvyInformatizaciaSpolocnostiZiadne: false,
  vplyvyInformatizaciaSpolocnostiNegativne: false,
  vplyvyVerejnaSpravaObcanPozitivne: false,
  vplyvyVerejnaSpravaObcanZiadne: false,
  vplyvyVerejnaSpravaObcanNegativne: false,
  vplyvyProcesyVerejnejSpravyPozitivne: false,
  vplyvyProcesyVerejnejSpravyZiadne: false,
  vplyvyProcesyVerejnejSpravyNegativne: false,
  vplyvyManzelstvoRodicovstvoPozitivne: false,
  vplyvyManzelstvoRodicovstvoZiadne: false,
  vplyvyManzelstvoRodicovstvoNegativne: false,
  poznamky: '',
  kontaktSpracovatel: '',
  zdroje: '',
  stanoviskoPpkC: '',
  stanoviskoPpkSuhlasne: false,
  stanoviskoPpkSuhlasneNaDopracovanie: false,
  stanoviskoPpkNesuhlasne: false,
  stanoviskoPpkVyhodnotenie: '',
  stanoviskoPosudenieC: '',
  stanoviskoPosudenieSuhlasne: false,
  stanoviskoPosudenieSuhlasneNaDopracovanie: false,
  stanoviskoPosudenieNesuhlasne: false,
  stanoviskoPosudenieVyhodnotenie: '',
});

export default initFormData;
